import React, { Component, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ErrorBoundaryState {
	hasError: boolean;
	error?: Error;
	errorInfo?: React.ErrorInfo;
	redirectToErrorPage: boolean;
}

interface ErrorBoundaryProps {
	children?: ReactNode;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: {}) {
		super(props);
		this.state = { hasError: false, redirectToErrorPage: false };
	}

	static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
		return { hasError: true, redirectToErrorPage: true };
	}

	render() {
		if (this.state.redirectToErrorPage) {
			return <Navigate to='/error-page' replace />;
		}
		return this.props.children || null;
	}
}

export default ErrorBoundary;
